import { useDroppable } from '@dnd-kit/core';
import OpportunityCard, { BoardOpp, Broker } from './OpportunityCard';
const money = (n: number) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export interface BoardStage { id: string; name: string; count: number; value: number; opportunities: BoardOpp[]; }

export default function StageColumn({ stage, brokers, onCardClick, sortKey, personaFilter }: {
  stage: BoardStage; brokers: Record<string, Broker>; onCardClick: (id: string) => void;
  sortKey: 'value' | 'age' | 'updated';
  personaFilter: string | null;
}) {
  const { setNodeRef, isOver } = useDroppable({ id: stage.id });

  // filter by persona label when a filter is active; null persona_label cards are hidden when a filter is active
  const filtered = personaFilter
    ? stage.opportunities.filter((o) => o.persona_label === personaFilter)
    : stage.opportunities;

  const sorted = [...filtered].sort((a, b) => {
    if (sortKey === 'value') return (Number(b.monetary_value) || 0) - (Number(a.monetary_value) || 0);
    if (sortKey === 'age') return new Date(a.last_stage_change_at || 0).getTime() - new Date(b.last_stage_change_at || 0).getTime();
    return new Date(b.updated_at || 0).getTime() - new Date(a.updated_at || 0).getTime();
  });

  return (
    <div className="min-w-[240px] w-[240px] bg-gray-50/80 rounded-2xl p-2.5 flex-shrink-0">
      <div className="flex items-center justify-between px-1 pb-2 mb-2 border-b border-gray-200/70">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 truncate">{stage.name}</span>
        <span className="text-[11px] text-gray-400 tabular-nums whitespace-nowrap">
          {sorted.length}{stage.value ? ` · ${money(stage.value)}` : ''}
        </span>
      </div>
      <div ref={setNodeRef} className={`min-h-[40px] rounded-xl transition-colors ${isOver ? 'bg-info-wash/70' : ''}`}>
        {sorted.map((o) => (
          <OpportunityCard key={o.id} opp={o} broker={o.assigned_to ? brokers[o.assigned_to] : undefined} onClick={() => onCardClick(o.id)} />
        ))}
      </div>
    </div>
  );
}
